import { push } from 'react-router-redux';
import { call, put, select } from 'redux-saga/effects';

import * as Actions from '../../../actions';
import * as Constants from '../../../constants';
import { ShortCircuitError, TaskManagerError } from '../../../lib/error';
import * as Utils from '../../../utils';

import * as SignUpHelpers from './helpers';

export function* signUp(action) {
  try {
    yield call(SignUpHelpers.registerListener, action);

    const shouldNavigateToCommunity = yield select(Utils.Application.shouldNavigateToCommunity);
    if (shouldNavigateToCommunity) {
      yield call(SignUpHelpers.navigateToCommunity);
      return;
    }

    const ampSSO = yield select(Utils.QueryParams.getAmpSSO);
    if (ampSSO) {
      const ampUrl = yield select(Utils.TunerVars.getAmpUrl, ampSSO);
      if (ampUrl) {
        yield put(Actions.Application.externalRedirect(ampUrl));
        return;
      }
    }

    yield call(SignUpHelpers.postRegistration);
  } catch (err) {
    if (err instanceof TaskManagerError) {
      if (err.some(ShortCircuitError, Constants.ListenerExternals.Errors.USER_IS_UNDERAGE)) {
        yield put(Actions.Listener.registerAttemptBlocked());
        yield put(push(Utils.Route.getRegistrationBlockedPath()));
      }
    } else {
      throw err;
    }
  }
}
